import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PlexEnvironment } from '@app/env';
import { AuthService } from 'app/auth/auth.service';
import { MenuItem } from 'app/shared/models/menu-item';
import { BehaviorSubject } from 'rxjs';
import { menuItemsCem } from './menu-items';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private router = inject(Router);
  private auth = inject(AuthService);
  private environment = inject(PlexEnvironment);

  private currentState: MenuItem[];
  private menuItems: MenuItem[];
  private menuItemsOb: BehaviorSubject<MenuItem[]>;

  public currentParent: MenuItem;
  public currentChild: MenuItem;

  private routeNavEnd: NavigationEnd;

  constructor() {
    this.menuItemsOb = new BehaviorSubject([]);

    //MANUAL FILTER OUT ITEMS UNTIL NEEDED

    this.auth.$permissions.subscribe(p => {
      this.applyFilters();
    });

    this.filterItems(this.routeNavEnd?.urlAfterRedirects ?? this.router.url);
    this.router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        this.routeNavEnd = s as NavigationEnd;
        this.applyFilters();
      }
    });

    this.applyFilters();

  }
  private applyFilters() {
    this.filterItems(this.routeNavEnd?.urlAfterRedirects ?? this.router.url);
  }

  private filterItems(url) {
    const menuItems = this.filterByRoute(url, menuItemsCem);

    this.menuItems = this.environment.security ? this.parseMenu(menuItems) : menuItems;

    this.menuItemsOb.next(this.menuItems);
  }

  private canUserAccessMenuItem(menuItem: MenuItem): boolean {
    if (menuItem.security && menuItem.security.length > 0)
      return this.auth.userHasAnyRole(menuItem.security);
    else return true;
  }

  private parseMenu(menu: MenuItem[]) : MenuItem[]{
    //filter top-level menu items
    let filteredMenu = menu.filter(mi => this.canUserAccessMenuItem(mi));

    //filter children on remaining menu items
    filteredMenu.forEach(mi => {
      mi.children = mi.children?.filter(cmi => this.canUserAccessMenuItem(cmi));
    })

    return filteredMenu;
  }

  private filterByRoute(url: string, allMenuItems: MenuItem[]) {
    let removeItems = [];
    if (url == '/forecasts/scenarios') {
      removeItems = ["Projects", "Items", "Scoping Items", "Standard Configs", "Project Teams", "Wells", "Depths", "Equation Manager", "Admin", "Acct Proj Updates"];
    } else {
      removeItems = ["Depths", "Equation Manager", "Admin"];
    }

    const menuItems = allMenuItems.filter((item) => {
      if (removeItems.includes(item.name)) {
        return false;
      }
      return true;
    });
    return menuItems;
  }

  getAll(): MenuItem[] {
    return this.menuItems;
  }

  getAllAsync(): BehaviorSubject<MenuItem[]> {
    return this.menuItemsOb;
  }

  navigateTo(menuItem: MenuItem): void {
    this.router.navigateByUrl(menuItem.state);
  }

  getCurrentState(): MenuItem[] {
    let path = this.router.routerState.snapshot.url.split('/');
    path.shift();

    this.currentState = [];

    let returnedItem: MenuItem;

    for (let index = 0; index < path.length; index++) {
      // If this is the first pass, get all the menu items
      let menuItems = this.menuItems;

      if (index !== 0) {
        // If this is not the first pass, reassign menu to the children
        menuItems = returnedItem && returnedItem.children;
      }

      if (typeof menuItems !== 'undefined') {
        returnedItem = this.addState(menuItems, path, index);
        if (!returnedItem) {
        }
      } else {
        return this.currentState;
      }
    }

    return this.currentState;
  }

  private addState(menuItems: MenuItem[], path: string[], index: number): MenuItem {
    let item = menuItems.find(menuItem => menuItem.state === path[index]);
    this.currentState.push(item);

    return item;
  }
}